// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'leaf-solid';

export const Component = () => (
  <path d='M10.729 10.764 9.579 5.21C13.46 3.149 18.25 2.048 24.044 2c.096 0 .191 0 .239.048-1.677.67-3.784 1.772-6.226 3.352-2.49 1.58-4.933 3.4-7.327 5.364Zm4.119-2.012.096-.096 8.237 2.107c.862-2.442 1.293-5.029 1.34-7.758-3.639 1.628-6.848 3.543-9.673 5.747Zm-4.982 2.73L8.67 5.735C3.017 9.231.144 14.978 0 23.073v.096c1.293-3.353 4.598-7.232 9.866-11.686v-.001Zm-4.07 5.077v.047l11.877 1.964c2.347-1.868 4.023-4.167 5.125-6.801l-8.86-2.347a70.53 70.53 0 0 0-8.142 7.136ZM.96 23.455l-.048.097c6.56-.097 11.781-1.485 15.66-4.167L4.983 17.47a18.283 18.283 0 0 0-4.024 5.986Z' />
);

export const viewBox = '0 0 25 25';
